import { useQuery } from '@tanstack/react-query'
import { useSelectedSeller } from '@/modules/shared/hooks/use-selected-seller'
import { useMemo, useState } from "react";
import { demonstrativoMetaFamilaTotalMesServiceByDates } from "../services/demonstrativo-meta-familia-total-mes.service";
import { DemonstrativoMetaFamiliaMesTotal } from "../types/demonstrativo-meta-familia-mes-total";





export function useDemonstrativoMetaFamilaTotalMes(dataInicial = new Date()) {
	const [dataReferencia, setDataReferencia] = useState(
    new Date(dataInicial.getFullYear(), dataInicial.getMonth(), 1)
  );
  const selectedSeller = useSelectedSeller()

  const periodo = useMemo(() => {
    const ano = dataReferencia.getFullYear();
    const mes = dataReferencia.getMonth();

    const dataInicio = new Date(ano, mes, 1);
    const dataFim = new Date(ano, mes + 1, 0);

    return {
      dataInicio: dataInicio.toISOString(),
      dataFim: dataFim.toISOString(),
      ano,
      mes: mes + 1,
    };
  }, [dataReferencia]);

  function mesAnterior() {
    setDataReferencia(prev =>
      new Date(prev.getFullYear(), prev.getMonth() - 1, 1)
    );
  }

  function proximoMes() {
    setDataReferencia(prev =>
      new Date(prev.getFullYear(), prev.getMonth() + 1, 1)
    );
  }

  function irParaMes(ano: number, mes: number) {
    setDataReferencia(new Date(ano, mes - 1, 1));
  }

  const {
    data: dataDemonstrativoMetaFamilaTotalMes = [],
    isFetching: isLoading,
    refetch,
  } = useQuery<DemonstrativoMetaFamiliaMesTotal[]>({
    queryKey: ['demonstrativo-meta-familia-total-periodo', periodo.dataInicio, periodo.dataFim, selectedSeller],
    queryFn: async () => {
      const { body } = await demonstrativoMetaFamilaTotalMesServiceByDates({
        dataInicio: periodo.dataInicio,
        dataFim: periodo.dataFim,
        vendedor: selectedSeller,
      })
      const data = JSON.parse(body)
      return Array.isArray(data) ? data : data ? [data] : []
    },
    staleTime: 0,
    refetchOnWindowFocus: false,
  })

  return {
    dataDemonstrativoMetaFamilaTotalMes,
    isLoading,

    dataReferencia,
    dataInicio: periodo.dataInicio,
    dataFim: periodo.dataFim,
    ano: periodo.ano,
    mes: periodo.mes,

    mesAnterior,
    proximoMes,
    irParaMes,
    refetch,
  };
}

